import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Authorities from "../../../auth/authorities";
import { getIsAuthorized } from "../../../utils/authorities";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Location from "../../PrestoExpressLocationApp/pages/Location";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AlertConfig from "../pages/AlertConfig";
import AvailabilityPage from "../pages/AvailabilityPage";
import MetricsListPageNewNew from "../pages/MetricsListPageNewNew";
import MetricsListShowPageNew from "../pages/MetricsListShowPageNew";
import SettingPage from "../pages/SettingPage";
import HistoricalPreparationPage from "../pages/HistoricalAnalytics/PreparationPage";
import HistoricalStationPage from "../pages/HistoricalAnalytics/StationPage";
import HistoricalLoadPage from "../pages/HistoricalAnalytics/LoadPage";
import HistoricalDeliveryPage from "../pages/HistoricalAnalytics/DeliveryPage";
import { Icon } from "@iconify/react";

export const getSidebarRoutes = () => {
  const sidebarRoute = [
    {
      id: "Dashboard",
      title: "Dashboards",
      path: "/dashboard",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    // Each report takes the icon of the step it measures, so the list can be
    // read down the icons alone: kitchen, handover, road, screen.
    {
      id: "Historical Preparation",
      title: "Preparation Time Report",
      path: "/historical/preparation",
      icon: <Icon icon="mdi:chef-hat" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Historical Load",
      title: "Load Time Report",
      path: "/historical/load",
      icon: <Icon icon="mdi:package-variant-closed" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Historical Delivery",
      title: "Delivery Time Report",
      path: "/historical/delivery",
      icon: <Icon icon="mdi:moped-outline" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Historical Stations",
      title: "Station Time Report",
      path: "/historical/stations",
      icon: <Icon icon="mdi:monitor-dashboard" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Alert Config",
      title: "Alert Configuration",
      path: "/alertConfig",
      icon: <Icon icon="mdi:bell-alert-outline" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Availability",
      title: "Availability",
      path: "/availability",
      icon: <Icon icon="mdi:calendar-clock-outline" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "internal",
      title: "Internal Configurations",
      path: "/internalConfiguration",
      icon: <Icon icon="ri:admin-line" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
      childRoutes: [
        {
          id: "resetConfiguration",
          title: "Reset Configuration",
          path: "/internalConfiguration/resetConfiguration",
          icon: <Icon icon="dashicons:admin-generic" height="24" width="24" />,
          isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
        },
      ],
    },
  ];
  return sidebarRoute;
};
export interface InsightAppRoutesProps {}

const InsightAppRoutes: React.FunctionComponent<InsightAppRoutesProps> = () => {
  const location = useLocation();

  return (
    <Switch>
      <Route
        path="/:locationId/presto-insight/dashboard"
        component={MetricsListPageNewNew}
        exact
      />
      <Route
        path="/:locationId/presto-insight/historical/preparation"
        component={HistoricalPreparationPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/historical/load"
        component={HistoricalLoadPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/historical/delivery"
        component={HistoricalDeliveryPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/historical/stations"
        component={HistoricalStationPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/alertConfig"
        component={AlertConfig}
        exact
      />
      <Route
        path="/:locationId/presto-insight/availability"
        component={AvailabilityPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/internalConfiguration/resetConfiguration"
        component={SettingPage}
        exact
      />

      <Route
        path="/:locationId/presto-insight/public/:layoutId"
        component={MetricsListShowPageNew}
        exact
      />
      <Route path="/" component={Location} exact />
    </Switch>
  );
};

export default InsightAppRoutes;
